import(/* webpackChunkName: "ember-utilities" */ './app/app/app');
import('react-core/lib/settings');
